import { useSession } from "./useSession";

export function useCanWrite(): boolean {
  const session = useSession();
  const role = session.data?.role;
  return role === "editor" || role === "admin";
}
